const accordion = () => {
  // トリガークラス'.js-accordion-trigger'を持つ要素を取得
  const trigger = document.getElementsByClassName('js-accordion');

  if (trigger.length === 0) return;

  // console.log(trigger);
  for (let i = 0; i < trigger.length; i = i + 1 || 0) {
    trigger[i].addEventListener('click', (e) => {
      // クリックされた要素（トリガー要素）を取得
      const currentElement = e.currentTarget as HTMLElement;

      // 同じ親要素を持つ隣接した次の要素'.js-accordion-target'（展開対象の要素）を取得.nextElementSibling;

      const targetContnents = currentElement.nextElementSibling as HTMLElement;

      if (targetContnents.style.height) {
        // トリガーの'is-opened'クラスを削除
        currentElement.classList.remove('is-open');
        //
        targetContnents.style.height = '';
      } else {
        // トリガーの'is-opened'クラスを追加
        currentElement.classList.add('is-open');

        // scrollHeightプロパティはpaddingを含む表示されていない要素の高さを取得
        targetContnents.style.height = `${targetContnents.scrollHeight}px`;
      }
    });
  }
};
export { accordion };
